import { render, staticRenderFns } from "./StartPage.vue?vue&type=template&id=83c64664&scoped=true&"
import script from "./StartPage.vue?vue&type=script&lang=js&"
export * from "./StartPage.vue?vue&type=script&lang=js&"
import style0 from "./StartPage.vue?vue&type=style&index=0&id=83c64664&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83c64664",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContent } from 'vuetify/lib/components/VContent';
installComponents(component, {VContent})
